import { Controller, useFormContext } from 'react-hook-form';
import { clsx } from 'clsx';
import { SvgCloseSearch } from '@/components/icons';
import { ControlledInputProps } from '@/components/form/ControlledInput/ControlledInput.types';
import s from './ControlledInput.module.scss';

export const ControlledInput = (props: ControlledInputProps) => {
  const {
    fieldName,
    placeholder = 'Введите',
    disabled,
    className,
    label,
  } = props;

  const { control, resetField } = useFormContext();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <div className={clsx(s.inputWrapper, className, { [s.input_disabled]: disabled })}>
          {label && <div className={s.inputWrapper__label}>{label}</div>}
          <input
            className={clsx(s.input, className, {
              [s.input_disabled]: disabled,
              [s.input_error]: error,
            })}
            ref={ref}
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder={placeholder}
          />
          {value && (
            <button
              className={clsx(s.input__cross, { [s.input__cross_shifted]: label })}
              type="button"
              onClick={() => resetField(fieldName)}
            >
              <SvgCloseSearch />
            </button>
          )}
          <span className={clsx(s.input__errorHint, { [s.input__errorHint_visible]: error })}>
            {error?.message}
          </span>
        </div>
      )}
    />
  );
};